export default __webpack_public_path__ + "static/media/pa.1757b8e7.png";